// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CommentForm_wrapper__CiMtB","button":"CommentForm_button__3n5HZ"};